module.exports = __webpack_public_path__ + "static/img/zhuoxin.0c34abe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/zhuoxin.png
// module id = VO9Q
// module chunks = 1